import { Box } from '@alto-avios/alto-ui'
import { CabinClass, Carrier } from '@reward-platform/flights-schemas'
import React from 'react'
import OpCoLogo from '~/components/search-and-results/FlightCard/OpCoLogo'
import useCabinClassTranslations from '~/hooks/useCabinClassTranslations'
import { useOperatedBy } from '~/hooks/useOperatedBy/useOperatedBy'
import styles from './FlightCarrier.module.scss'

type Props = {
  flightNumber: string
  marketingCarrier: {
    carrier: Carrier
  }
  operatingCarrier: {
    carrier: Carrier
  }
  variant?: string
  cabinClass?: CabinClass
}

export function FlightCarrier({
  flightNumber,
  marketingCarrier,
  operatingCarrier,
  cabinClass,
}: Readonly<Props>) {
  const { operatedBy } = useOperatedBy(operatingCarrier.carrier)
  const cabinClassTranslations = useCabinClassTranslations()

  return (
    <Box className={styles.flightCarrier} data-testid="flight-carrier">
      <span className={styles.flightNumber}>
        {cabinClass && `${cabinClassTranslations[cabinClass]} •`}{' '}
        {marketingCarrier.carrier + flightNumber}
      </span>
      {operatedBy && <span className={styles.operatedBy}>{operatedBy}</span>}
      <span className={styles.operatedByLogo}>
        <OpCoLogo operator={operatingCarrier.carrier} />
      </span>
    </Box>
  )
}
